import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { Nav, NavItem, Card } from "react-bootstrap";
import "./SideNavigation.css";

export default function SideNavigationMenu(props) {
  const activeStyle = { 
    backgroundColor: "#005867", 
    color: "white",
    borderRadius: "4px"
  };
  
  return (
    <div className="side-nav-container">
      {/* Main Header Stripe */}
      <div className="side-nav-main-header">
        <h4 className="main-header-title">Administration</h4>
      </div>
      
      {/* Main Navigation Section - without header */}
      <Card className="side-nav-card mb-3 mt-3">
        <Card.Body className="p-2">
          <Nav className="flex-column">
            <NavItem className="nav-item">
              <NavLink to="/administration/reports" activeStyle={activeStyle} className="nav-link p-2 side-nav-link">
                Rev Share Reports
              </NavLink>
            </NavItem>
            <NavItem className="nav-item">
              <NavLink to="/administration/admin" activeStyle={activeStyle} className="nav-link p-2 side-nav-link">
                Admin Tools
              </NavLink>
            </NavItem>
            <NavItem className="nav-item">
              <NavLink to="/administration/presclubadmin" activeStyle={activeStyle} className="nav-link p-2 side-nav-link">
                President's Club
              </NavLink>
            </NavItem>
          </Nav>
        </Card.Body>
      </Card>
    </div>
  );
}

SideNavigationMenu.propTypes = {
  isAdmin: PropTypes.bool
};